import { amplitudeLib } from 'freedom-shared';

export const quizBannerClick = () => {
  amplitudeLib.logEvent('avfree_quiz_banner_click');
};

export const quizPageViewed = () => {
  amplitudeLib.logEvent('avfree_quiz_page_viewed');
};

export const quizQuestion = (params: { number: number }) => {
  amplitudeLib.logEvent('avfree_quiz_question', params);
};

export const quizNextQuestion = (params: { answer: string }) => {
  amplitudeLib.logEvent('avfree_quiz_next_question', params);
};

export const quizFinal = () => {
  amplitudeLib.logEvent('avfree_quiz_final');
};

export const takePromocodeClick = () => {
  amplitudeLib.logEvent('avfree_take_promocode_click');
};

export const otherRoutesClick = () => {
  amplitudeLib.logEvent('avfree_other_routes_click');
};
